import React from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// LOCAL COMPONENTS
import Card from 'parts/card/Card';
import Attachment from 'routers/interface/tools/attachment/Attachment';
import Form from 'core/form/Form';

// STYLES
import styles from '../../trade.module.scss';

// MAIN COMPONENT
const InventoryAttachmentForm = ({ index }) => {

  // FORMIK CONTEXT
  const { values } = useFormikContext();

  const vehicle = values.aryTrade?.[index]?.inventory;
  const stockNum = vehicle?.stock_num;
  const vinNum = vehicle?.vin_num;
  const dailySalesInventoryId = vehicle?.daily_sales_inventory_id;
  const uploadParams = { stockNum, vinNum, dailySalesInventoryId };
  const noVinStock = !stockNum || !vinNum;

  // RENDER
  return (
    <Form.Body.Vertical className={styles.body}>
      <Attachment.Upload
        label="Other"
        name={`aryTrade[${index}].inventory.documentAttachment.other`}
        documentType={2}
        documentCode="other"
        uploadType="inventory"
        docrName={`aryTrade[${index}].inventory.docrAttachmentRequest`}
        requestedFor="Inventory"
        uploadParams={uploadParams}
        noVinStock={noVinStock}
        vehicle={vehicle}
      />
      <Attachment.Upload
        label="DX Documents"
        name={`aryTrade[${index}].inventory.documentAttachment.dx`}
        documentType={8}
        documentCode="dx"
        uploadType="inventory"
        docrName={`aryTrade[${index}].inventory.docrAttachmentRequest`}
        requestedFor="Inventory"
        uploadParams={uploadParams}
        noVinStock={noVinStock}
        vehicle={vehicle}
      />
    </Form.Body.Vertical>
  );
};

export default function InventoryAttachments(props) {
  return <Card title="Inventory Attachments" className="w-100" body={<InventoryAttachmentForm {...props} />} />;
}
